module.exports = __webpack_public_path__ + "img/Frame-26.bbe35a0f.svg";